export default "__VITE_ASSET__91fde925__"